/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsFacebookPublicAuthOptions, FxIdDomainSettingsFacebookPublicAuthOptionsFromJSONTyped, FxIdDomainSettingsFacebookPublicAuthOptionsToJSON, } from './FxIdDomainSettingsFacebookPublicAuthOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsFacebookPublicAuthOptions(json)) {
        return FxIdDomainSettingsFacebookPublicAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsFacebookPublicAuthOptions(value)) {
        return FxIdDomainSettingsFacebookPublicAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebook.js.map